import { useContext, useEffect } from "react";
import { auth } from "../firebase/config";
import UserContext from "../context/UserContext";

const InactivityHandler = () => {
  const { user, setUser } = useContext(UserContext);

  const INACTIVITY_LIMIT = 3 * 60 * 60 * 1000; // 3 horas en milisegundos
  let timeoutId; 

  const actualizarUltimaActividad = () => {
    localStorage.setItem("ultimaActividad", Date.now());

    clearTimeout(timeoutId);
    iniciarTemporizador();
  };

  const iniciarTemporizador = () => {
    timeoutId = setTimeout(() => {
      handleLogout();
    }, INACTIVITY_LIMIT);
  };

  const verificarInactividad = () => {
    const ultimaActividad = localStorage.getItem("ultimaActividad");
    const ahora = Date.now();

    if (ultimaActividad && ahora - parseInt(ultimaActividad, 10) > INACTIVITY_LIMIT) {
      handleLogout();
    } else {
      iniciarTemporizador();
    }
  };

  const handleLogout = () => {
    auth.signOut();
    setUser(null);
    localStorage.removeItem("usuario");
    localStorage.removeItem("ultimaActividad");
    window.location.href = "/login";
  };

  useEffect(() => {
    verificarInactividad();

    window.addEventListener("mousemove", actualizarUltimaActividad);
    window.addEventListener("keydown", actualizarUltimaActividad);
    window.addEventListener("scroll", actualizarUltimaActividad);
    window.addEventListener("touchstart", actualizarUltimaActividad);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("mousemove", actualizarUltimaActividad);
      window.removeEventListener("keydown", actualizarUltimaActividad);
      window.removeEventListener("scroll", actualizarUltimaActividad);
      window.removeEventListener("touchstart", actualizarUltimaActividad);
    };
  }, []);

  return null;
};

export default InactivityHandler;

